import Request from './request'
async function fetch(data){
    return Request("get","api/payment/get-pay-settings",data)
}

async function editAppPay(data){
    return Request("get","api/payment/edit-app-pay?app_pay=" + data)
}

async function alipay(data){
    return Request("get","api/settings",data)
}

async function alipaySave(data){
    return Request("post","api/payment/alipay-h5-save",data)
}

async function weChatPaySave(data){
    return Request("post","api/payment/wechat-pay-save",data)
}

async function wechatV3PaySave(data){
    return Request("post","api/payment/wechat-v3-save",data)
}

async function wechatB2BPaySave(data){
    return Request("post","api/payment/wechat-b2b-save",data)
}

async function chinaFileUpload(file,check){
    var data = new FormData()
    data.append("sign_file",file);
    data.append("chinapay_sign_check",check);
    return Request("post","api/payment/china-file-upload",data)
}

async function hfFileUpload(file){
    var data = new FormData()
    data.append("sign_file",file);

    return Request("post","api/payment/hf-file-upload",data)
}

async function wechatV3FileUpload(type, file){
    var data = new FormData()
    data.append("type",type);
    data.append("sign_file",file);

    return Request("post","api/payment/wechat-v3-file-upload", data)
}

async function wechatV2FileUpload(type, file){
    var data = new FormData()
    data.append("type",type);
    data.append("sign_file",file);

    return Request("post","api/payment/wechat-v2-file-upload", data)
}

async function hfPaySave(data){
    return Request("post","api/payment/hf-pay-save",data)
}

async function chinaPaySave(data){
    return Request("post","api/payment/china-pay-save",data)
}

async function LftPaySave(data){
    return Request("post","api/payment/lft-pay-save",data)
}

async function EasyPaySave(data){
    return Request("post","api/payment/easy-pay-save",data)
}

async function newLandPaySave(data){
    return Request("post","api/payment/new-land-pay-save",data)
}

async function WsFileUpload(file){
    var data = new FormData()
    data.append("sign_file",file);

    return Request("post","api/payment/wsbank-file-upload",data)
}

async function WsSave(data){
    return Request("post","api/payment/wsbank-save",data)
}

async function HfdgSave(data){
    return Request("post","api/payment/hfdg-pay-save",data)
}

async function SxfSave(data) {
    return Request("post","api/payment/sxf-pay-save",data)
}

async function CCBPaySave(data) {
    return Request("post","api/payment/ccb-bank-scan-save",data)
}

async function lakalaFileUpload(file, type) {
    let data = new FormData()
    data.append("type", type);
    data.append("sign_file", file);
    return Request("post","api/payment/lakala-file-upload", data)
}

async function LKLPaySave(data) {
    return Request("post", "api/payment/lakala-save", data)
}

async function LCSWPaySave(data) {
    return Request("post", "api/payment/lcsw-save", data)
}

async function LCSWCBKPaySave(data) {
    return Request("post", "api/payment/lcsw-cbk-save", data)
}

async function CrowdPaySave(data) {
    return Request("post", "api/payment/crowdpay-save", data)
}

async function queryAccountInfo(data) {
    return Request("post", "api/lcsw-interface/query-account-info", data)
}


export default {
    fetch,
    editAppPay,
    alipay,
    alipaySave,
    weChatPaySave,
    chinaFileUpload,
    chinaPaySave,
    LftPaySave,
    EasyPaySave,
    hfFileUpload,
    hfPaySave,
    newLandPaySave,
    WsFileUpload,
    WsSave,
    HfdgSave,
    SxfSave,
    CCBPaySave,
    lakalaFileUpload,
    LKLPaySave,
    LCSWPaySave,
    wechatV3PaySave,
    wechatB2BPaySave,
    wechatV3FileUpload,
    wechatV2FileUpload,
    LCSWCBKPaySave,
    CrowdPaySave,
    queryAccountInfo,
}